import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const GET_MI_DASHBOARD_REQUEST = 'GET_MI_DASHBOARD_REQUEST';
export const GET_MI_DASHBOARD_SUCCESS = 'GET_MI_DASHBOARD_SUCCESS';
export const GET_MI_DASHBOARD_FAILURE = 'GET_MI_DASHBOARD_FAILURE';

function requestMiDashboard() {
  return {
    type: GET_MI_DASHBOARD_REQUEST,
    isGettingMiDashboard: true,
    miData: null,
    error: null
  };
}

function receiveMiDashboard(miData) {
  return {
    type: GET_MI_DASHBOARD_SUCCESS,
    isGettingMiDashboard: false,
    miData
  };
}

function rejectMiDashboard(error) {
  return {
    type: GET_MI_DASHBOARD_FAILURE,
    isGettingMiDashboard: false,
    miData: null,
    error
  };
}

export function getMiDashboard(clientId, fromDate, toDate, trend, includeDeletedForms) {
  return (dispatch) => {
    dispatch(requestMiDashboard());

    const promise = () => ApiService
      .getMiDashboard(clientId, fromDate, toDate, trend, includeDeletedForms)
      .then((response) => {
        dispatch(receiveMiDashboard(response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectMiDashboard, false));
        }
      });
    return promise();
  };
}
